export default "__VITE_PUBLIC_ASSET__628d21f8__"